import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, AlertTriangle } from 'lucide-react';
import { useMetadata } from '../hooks/useMetadata';

export default function NotFound() {
  const [cmsPage, setCmsPage] = useState(null);

  useEffect(() => {
    fetch('https://api.dev.auxo.dk/public/by-slug/da/404')
      .then((res) => {
        if (!res.ok) throw new Error('Kunne ikke hente 404 fra CMS');
        return res.json();
      })
      .then((data) => {
        if (data && data.collectionName === 'pages') {
          setCmsPage(data);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  const title = cmsPage?.meta_title || 'Siden blev ikke fundet - FLOW Transport & Logistik ApS';
  const description = cmsPage?.meta_description || 'Beklager, men siden blev ikke fundet. Gå tilbage til forsiden for at finde det, du søger.';

  useMetadata(title, description);

  return (
    <div className="min-h-[70vh] bg-slate-50 flex items-center justify-center px-4 py-16 font-sans">
      <div className="max-w-md w-full text-center space-y-6 bg-white p-8 sm:p-10 rounded-2xl shadow-3d-card border border-slate-100">
        <div className="inline-flex p-4 rounded-full bg-amber-50 text-amber-600">
          <AlertTriangle className="h-12 w-12" />
        </div>
        
        <h1 className="text-3xl font-serif font-bold text-brand-dark tracking-tight">
          {cmsPage?.title || '404 - Siden blev ikke fundet'}
        </h1>

        <div
          className="text-slate-600 text-sm leading-relaxed"
          dangerouslySetInnerHTML={{ __html: cmsPage?.content || '<p>Beklager, men den side du leder efter findes ikke eller er blevet flyttet.</p>' }}
        />

        <div className="pt-4">
          <Link
            to="/"
            className="inline-flex items-center justify-center bg-brand-primary hover:bg-brand-primary/95 text-white px-6 py-3 rounded-lg text-sm font-bold uppercase tracking-wider transition-colors shadow cursor-pointer w-full"
          >
            <Home className="mr-2 h-4 w-4" />
            Gå til forsiden
          </Link>
        </div>
      </div>
    </div>
  );
}
